'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
/* istanbul ignore next */
function addEventListener() {
    if (typeof window !== 'undefined') {
        window.addEventListener.apply(window, arguments);
    }
}

/* istanbul ignore next */
function removeEventListener() {
    if (typeof window !== 'undefined') {
        window.removeEventListener.apply(window, arguments);
    }
}
//# sourceMappingURL=window.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/facades/window.js
// module id = 181
// module chunks = 0